import {Pipe, PipeTransform} from '@angular/core';

import {DomSanitizer} from '@angular/platform-browser';

@Pipe({ name: 'ConvertTimePipe'})

export class ConvertTimePipe implements PipeTransform  {

    constructor(protected sanitizer: DomSanitizer){}

    transform(value: string): string {
        const H =  this.getTime(value.substr(11, 2));
        const mm = value.substr(14, 2);
        const a = this.getAmPm(value.substr(11, 2));
        const time = `${H}:${mm}`;

        return `${time}`;
    }

    getTime(time){
        return  (time.substr(0, 1) !== '0' && Number(time) > 12) ? Number(time) - 12  : Number(time);
    }

    getAmPm(time){
        return  (time.substr(0, 1) === '0' || Number(time) < 12) ? 'AM' : 'PM';
    }
}
